import enterprise from './enterprise/store';
import stats from './stats/store';

export default {
  namespaced: true,
  modules: { enterprise, stats },
};
